import config from '@/config/index'
import {post, get} from "../server/http"

export const awakenLogAdd = (p) => post(`${config.M1_SERVER}v3/awaken/log`, p)

export const getIp =(p) => get(`${config.M1_SERVER}v3/ip/get`, p)

